import React from 'react';
import CloseIcon from '@mui/icons-material/Close';
import BaseModal from '../BaseModal';
import WithCloseIcon from '../../ComposableWrappers/WithCloseIcon/WithCloseIcon';
import JobAlertForm from './components/JobAlertForm';
import { useWindowSize } from '../../../../utils/hooks';
import classes from './JobAlertModal.module.scss';
import { MOBILE_BREAKPOINT } from '../../../../utils/constants';

export default function JobAlertModal(props) {
  const { type, title, closeHandler, confirmHandler, data = {} } = props;

  const size = useWindowSize();

  return (
    <BaseModal
      open={type}
      fullscreen={size.width < MOBILE_BREAKPOINT}
      closeHandler={closeHandler}
      confirmHandler={confirmHandler}
      title=""
      hideHeader
      hideFooter
      container={size.width < MOBILE_BREAKPOINT ? () => document.getElementById('quick-apply-container') : null}
      marginLeftRight={0}
    >
      <div
        className={classes.wrapper}
        style={{ position: size.width < MOBILE_BREAKPOINT ? 'sticky' : 'static', left: '0', right: '0', top: '80px' }}
      >
        <WithCloseIcon
          close={closeHandler}
          x={8}
          y={4}
          icon={
            <CloseIcon
              sx={{
                color: '#A3B4C7',
                fontSize: '16px',
                '&:hover': {
                  color: '#58595b'
                }
              }}
            />
          }
        >
          <JobAlertForm title={title} initialData={data} confirmHandler={confirmHandler} />
        </WithCloseIcon>
      </div>
    </BaseModal>
  );
}
